
<template>
  <v-container>
    <v-row>
      <v-col>
        <HelloWorld />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HelloWorld from "../components/Search";
export default {
    name: 'Home',
    components: {
        HelloWorld
    }
};
</script>

<style scoped>

</style>
